import $ from 'jquery'
import {initStore} from './redux/store'
import {Feature, isEnabled} from './features/index'
import {FAKE_WORKFLOW_STATUSES} from './workflowStatus/constants'
import {getSavedActiveTabNumOrDefault} from "./administration/userManagement/common/utils"
import {
    getCommentsOrderFromLocalStorage,
    getCustomerNewCommentsTextsFromLocalStorage,
    getProjectNewCommentsTextsFromLocalStorage,
    getTaskNewCommentsTextsFromLocalStorage
} from './panels/comments/utils'
import {getCpPanelClosedStateInLocalStorage, getSingleCPSelectionFromLocalStorage} from './taskManagement/common/utils'
import {initLocalStorage} from './util/LocalStorage'
import {loadCPPanelCollapsedCustomersFromLocalStorage, loadCpPanelWidthFromLocalStorage} from './taskManagement/customersProjectsPanel/utils'
import ToastsContainer from './toasts/components/ToastsContainer'
import {getStoredCollapsedProjectsState} from './taskManagement/kanban/utils'
import {getStoredDARSettingsCollapsedState} from './administration/darSettings/utils'
import LicenseCountDownTip from './activeLicenseInfo/LicenseCountDownTip'
import SupportQuestionButton from './support/supportForm/SupportQuestionButton'
import ContactSupportDraggablePopupContainer from './support/supportForm/ContactSupportDraggablePopupContainer'
import {clearSupportPopupInfoInLocalStorage as clearSupportPopupInfo, getSupportPopupInfoFromLocalStorage} from './support/supportForm/utils'
import WelcomeScreenContainer from './support/welcomeScreen/WelcomeScreenContainer'
import AddonsMenuContainer from './support/addons/AddonsMenuContainer'
import initUserEventListeners from './userEvents/initUserEventListeners'
import StartupWizard from './support/welcomeScreen/StartupWizard'
import {isOlVersion} from './constants'
import initIntercomIfNeeded from "./intercom/initIntercom";
import DemoDataLoaderContainer from "./support/welcomeScreen/DemoDataLoaderContainer";

/**
 * Common place for init all application data.
 * Place there initialization of all stores that used between several pages
 */
export default function initApplication() {
    const INIT_DATA = window.__INIT_APP_DATA__
    const GENERATED_CONSTANTS = window.__GENERATED_CONSTANTS__

    if (!INIT_DATA.WORKFLOW_STATUSES || !isEnabled(Feature.TWS)) {
        INIT_DATA.WORKFLOW_STATUSES = FAKE_WORKFLOW_STATUSES
    }

    // load data from cookies
    INIT_DATA.USER_MANAGEMENT.ACTIVE_TAB_NUM = getSavedActiveTabNumOrDefault()

    // load data from local storage
    initLocalStorage(INIT_DATA.LOGGED_IN_USER.id, GENERATED_CONSTANTS.CLIENT_CODE)

    if (window.__IS_FIRST_SCREEN_AFTER_LOGIN__) {
        cleanupLocalStorageForNewSession()
    }

    INIT_DATA.COMMENTS = {
        TASK_NEW_COMMENTS: getTaskNewCommentsTextsFromLocalStorage(),
        PROJECT_NEW_COMMENTS: getProjectNewCommentsTextsFromLocalStorage(),
        CUSTOMER_NEW_COMMENTS: getCustomerNewCommentsTextsFromLocalStorage(),
        IS_NEW_COMMENTS_ON_TOP: getCommentsOrderFromLocalStorage()
    }

    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_CLOSED = getCpPanelClosedStateInLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_WIDTH = loadCpPanelWidthFromLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_COLLAPSED_CUSTOMERS = loadCPPanelCollapsedCustomersFromLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.KANBAN_COLLAPSED_PROJECTS_STATE = getStoredCollapsedProjectsState()
    INIT_DATA.TASK_MANAGEMENT.SINGLE_CP_SELECTION = getSingleCPSelectionFromLocalStorage()

    INIT_DATA.GENERAL_SETTINGS = {
        DAR_SETTINGS_COLLAPSED_STATE: getStoredDARSettingsCollapsedState(),
    }

    INIT_DATA.SUPPORT = {
        ...INIT_DATA.SUPPORT,
        POPUP_INFO: {
            ...getSupportPopupInfoFromLocalStorage(),
        },
    }

    initStore(INIT_DATA)

    initUserEventListeners()

    initCommonComponents(INIT_DATA)
}

function initCommonComponents(INIT_DATA) {
    const intercomEnabled = initIntercomIfNeeded()
    const $body = $('body')
    new ToastsContainer().init($body)
    new LicenseCountDownTip().init($body)
    if (!intercomEnabled) {
        new SupportQuestionButton().init($('.contactSupportButtonPlaceholder'))
    }
    new ContactSupportDraggablePopupContainer().init()
    new AddonsMenuContainer().init()

    if (INIT_DATA.WELCOME.needToLoadDemoData) {
        new DemoDataLoaderContainer().init()
    }

    if (INIT_DATA.WELCOME.showWelcomeScreen) {
        if (isOlVersion) {
            new StartupWizard().init()
        } else {
            new WelcomeScreenContainer().init()
        }
    }
}

function cleanupLocalStorageForNewSession() {
    clearSupportPopupInfo()
}



// WEBPACK FOOTER //
// ./web/js/initApplication.js